// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"blank-m__wrapper__2pooo","meta-content":"blank-m__meta-content__26_XK","ad-slot":"blank-m__ad-slot__2Y0Fc"};